import { z } from 'zod'

import { DateZod, GeoPointZod } from '../../common'
import { CostFormulaZod } from '../../configuration/configuration-automated-assignment-minutes-zod'
import { TeamLocationZod } from '../../teams'

export const TeamAssigmentCostsZod = z.object({
  cost: z.number(),
  availability: z.number().or(z.enum(['now', 'unknown'])),
  availableAt: DateZod.optional(),
  availabilityWaitTimeCost: z.number(),
  teamWithoutPreciseGeolocationPenalty: z.number().optional(),
  locationWhenAvailable: z.union([
    TeamLocationZod,
    z.object({
      geolocation: GeoPointZod,
      transportRequestId: z.string(),
    }),
    z.object({
      geolocation: GeoPointZod,
      notUsingGeolocation: z.literal(true),
    }),
    z.enum(['unknown', 'outdated']),
  ]),
  availableTeamWaitTimeBonus: z.number().optional(),
  idleTimeInMinutes: z.number().optional(),
  availabilityMinutes: z.number().nullish(),
  equityMinutes: z.number().nullish(),
})

export const TransportRequestAssigmentCostsZod = z.object({
  waitTime: z.number(),
  waitTimeBonus: z.number(),
  cost: z.number(),
  waitedMinutes: z.number().nullish(),
  notServedCost: z.number().nullish(),
})

export const NotCandidateReasonZod = z.enum([
  'excluded',
  'onBreak',
  'manualTransmission',
  'beyondMaximumPickup',
  'unknownTerm',
])

export const TeamTransportRequestAssigmentCostsZod = z.object({
  distanceCost: z.number().optional(),
  estimatedDistance: z.number(),
  estimatedDistanceCost: z.number().optional(),
  realDistance: z.number().or(z.literal('unavailable')).optional(),
  realDistanceCost: z.number().or(z.literal('unavailable')).optional(),
  vehicleTypeCost: z.number().optional(),
  regionChangePenalty: z.number().optional(),
  excluded: z.boolean().optional(),
  aboveCostThreshold: z.boolean().optional(),
  assignmentCost: z.number().optional(),
  cost: z.number(),
  waitedMinutes: z.number().nullish(),
  availabilityMinutes: z.number().nullish(),
  travelMinutes: z.number().nullish(),
  outsideServicePointMinutes: z.number().nullish(),
  penaltyMinutes: z.number().nullish(),
  equityMinutes: z.number().nullish(),
  totalWaitMinutes: z.number().nullish(),
  weightedMinutes: z.number().nullish(),
  weightedCost: z.number().nullish(),
  notCandidate: NotCandidateReasonZod.nullish(),
})

export const AssignmentCostsZod = z.object({
  formula: CostFormulaZod.nullish().default('points'),
  minutesWeights: z.record(z.string(), z.number()).nullish(),
  teamIds: z.array(z.string()),
  transportRequestIds: z.array(z.string()),
  costs: z.record(z.record(z.number())),
  deleteAt: DateZod.optional(),
  details: z.object({
    teams: z.record(TeamAssigmentCostsZod),
    transportRequests: z.record(TransportRequestAssigmentCostsZod),
    // This is optional because it can be too big to store in firestore
    assignments: z.record(z.record(TeamTransportRequestAssigmentCostsZod)).optional(),
  }),
})
